import { provideApolloClient, useMutation } from '@vue/apollo-composable';
import apolloClients from '@/setup/apollo';
import { graphql } from '@/__generated__/gql';

// need to to this when outside of a vue setup function, so apollo knows where to look for the client
const { privateApolloClient } = apolloClients;
provideApolloClient(privateApolloClient);

const deleteHighlightMutation = graphql(`
  mutation DeleteHighlight($input: DeleteHighlightInput!) {
    deleteHighlight(input: $input) {
      success
    }
  }
`);

export const updateHighlightMutation = graphql(`
  mutation UpdateHighlight($input: UpdateHighlightInput!) {
    updateHighlight(input: $input) {
      highlight {
        ...HighlightParts
      }
    }
  }
`);

export const addHighlightMutation = graphql(`
  mutation AddHighlight($input: AddHighlightInput!) {
    addHighlight(input: $input) {
      __typename
      highlight {
        ...HighlightParts
      }
    }
  }
`);

export const addContentHighlightMutation = graphql(`
  mutation AddContentHighlight($input: AddContentHighlightInput!) {
    addContentHighlight(input: $input) {
      __typename
      highlight {
        ...HighlightParts
      }
    }
  }
`);

export const updateSelectedClassMutation = graphql(`
  mutation UpdateSelectedClass($input: UpdateSettingInput!) {
    updateSetting(input: $input) {
      success
      errors {
        field
      }
      user {
        id
        schoolClasses {
          ...SchoolClassParts
        }
        selectedClass {
          id
        }
      }
    }
  }
`);

const logoutMutation = graphql(`
  mutation LogoutMutation {
    logout {
      success
    }
  }
`);

const createContentBlockMutation = graphql(`
  mutation AddContentBlock($input: AddContentBlockInput!) {
    addContentBlock(input: $input) {
      newContentBlock {
        ...ContentBlockParts
        ...ContentBlockInterfaceParts
      }
      errors
      clientMutationId
    }
  }
`);

const { mutate: doCreateHighlight } = useMutation(addHighlightMutation);
const { mutate: doCreateContentHighlight } = useMutation(addContentHighlightMutation);
const { mutate: doDeleteHighlight } = useMutation(deleteHighlightMutation);
const { mutate: doUpdateHighlight } = useMutation(updateHighlightMutation);
const { mutate: doUpdateSelectedClass } = useMutation(updateSelectedClassMutation, {
  refetchQueries: ['MySchoolClassQuery', 'ModuleDetailsQuery'],
});
const { mutate: doLogout } = useMutation(logoutMutation);

const { mutate: doCreateContentBlock } = useMutation(createContentBlockMutation, {
  refetchQueries: ['ModuleDetailsQuery'],
});

const { mutate: doRedeemCoupon } = useMutation(
  graphql(`
    mutation RedeemCouponMutation($input: RedeemCouponInput!) {
      coupon(input: $input) {
        result {
          __typename
          ... on Success {
            message
          }
          ... on InvalidCoupon {
            reason
          }
        }
        me {
          ...UserParts
          team {
            ...TeamParts
          }
        }
      }
    }
  `)
);

const { mutate: doJoinClass } = useMutation(
  graphql(
    `
      mutation JoinClass($input: JoinClassInput!) {
        joinClass(input: $input) {
          result {
            ... on CodeNotValid {
              reason
            }
            ... on SchoolClassNode {
              id
              name
            }
            __typename
          }
          me {
            ...MySchoolClassFragment
            schoolClasses {
              ...SchoolClassParts
            }
          }
        }
      }
    `
  )
);

export {
  doDeleteHighlight,
  doUpdateHighlight,
  doCreateHighlight,
  doCreateContentHighlight,
  doUpdateSelectedClass,
  doLogout,
  doCreateContentBlock,
  doRedeemCoupon,
  doJoinClass,
};
